module.exports = __webpack_public_path__ + "img/download-qr.143b4c1c.svg";